import React from 'react';
import { Drawer, SIZE } from 'baseui/drawer';
import { useStyletron } from 'baseui';

import { CustomDrawerProps } from './type';

const CustomDrawer: React.FC<CustomDrawerProps> = ({ setDrawerConfig, drawerConfig }) => {
	const [css] = useStyletron();

	const handleClose = () => {
		setDrawerConfig({ isOpen: false });
	};

	return (
		<Drawer onClose={handleClose} isOpen={drawerConfig.isOpen} size={SIZE.auto}>
			<div
				className={css({
					width: '70vw'
				})}>
				{drawerConfig.content}
			</div>
		</Drawer>
	);
};

export default CustomDrawer;
